<template>
  <div class="favorites _pb-16 _bg-white">
    <!-- <div
      class="favorites-main__title _py-16 _py-sm-8 _fs-48 _lh-64 _fw-700 _fs-sm-32 _lh-sm-38 _bg-light _bg-md-white _px-md-4 _mb-6"
    >
      <div class="container">{{ $t('cabinet.title') }}</div>
    </div> -->
    <div class="container">
      <!-- <AppBtnBreadCrumb class="_mb-12 _mt-16 _my-sm-12 _ml-md-4" /> -->
      <div
        class="favorites__title _px-md-4 _mb-2 _fs-32 _lh-38 _fw-700 _fs-sm-24 _lh-sm-32 _tc-black"
      >
        {{ $t('cabinet.favorites.title') }}
      </div>
      <div
        class="favorites__title _px-md-4 _mb-6 _fs-24 _lh-32 _fs-sm-20 _lh-sm-26 _tc-dark-grey"
      >
        {{ $t('favorites.description') }}
      </div>
      <div class="favorites__filter _px-md-4 _mb-8">
        <div
          @click="choiceCategory(item)"
          class="favorites-filter__item"
          v-for="(item, i) in filter"
          :key="i"
          :class="{
            'favorites-filter__item_active': currentCategory === item.type,
          }"
        >
          {{ item.title }}
        </div>
      </div>
      <div
        class="sections__list d-grid row-1-1 gap-32 _px-md-4 _px-sm-0"
        v-if="Favorites && Favorites.length && blocks && blocks.length"
      >
        <VideoCard
          :simple="block.content_type === 'videoblock'"
          @viewItem="viewItem(...arguments, block.access_groups)"
          @like="like"
          @favorite="favorite"
          @setVideoProgress="setVideoProgress"
          @downloadFile="downloadFile"
          v-for="block in blocks"
          :key="block.system_id"
          :item="block"
          :analyticEventPrefix="analyticPrefixes[block.content_type]"
        >
          <!-- <template v-slot:button>
            <AppBtn
              v-if="block.content_type === 'videoblock'"
              class="_mt-4 _ml-md-4"
            >
              <a :href="block.link" target="_blank" class="_py-4 _px-6">
                <span class="_fs-16 _tc-white">Пройти тест</span>
              </a>
            </AppBtn>
          </template> -->
        </VideoCard>
      </div>
      <div
        v-else
        class="_px-md-4 _mb-2 _fs-32 _lh-38 _fw-700 _fs-sm-24 _lh-sm-32 _tc-black"
      >
        {{ $t('favorites.empty') }}
      </div>
    </div>
    <Pagination />
  </div>
</template>

<script>
import VideoCard from '@/components/UI/cards/VideoCard'
import Pagination from '../../components/UI/pagination/Pagination.vue'
// import AppBtnBreadCrumb from '@/components/UI/buttons/AppBtnBreadCrumb'
// import AppBtn from '@/components/UI/buttons/AppBtn'
import download from '@/mixins/download'
import { mapActions, mapGetters } from 'vuex'

export default {
  metaInfo() {
    return { title: this.$t('cabinet.dashboard.menu[4]') }
  },
  name: 'Favorites',
  mixins: [download],
  components: {
    VideoCard,
    Pagination,
    // AppBtnBreadCrumb,
    // AppBtn,
  },
  data: () => ({
    currentCategory: '',
  }),
  computed: {
    ...mapGetters(['Favorites']),
    filter() {
      return this.$t('favorites.filter').filter((el) => el.type !== 'webinar')
    },
    analyticPrefixes() {
      return {
        videoblock: 'distribution_material',
        webinar: 'webinars_material',
        material: 'webinars_additional_docs',
        link: 'webinars_additional_docs',
        hngrowitem: 'grow_material',
        training: 'trainings_material',
        successacademyelement: 'academy_material',
        intensivescreencast: 'intensive_scrncast_material',
        intensivelesson: 'intensive_lesson_material',
      }
    },
    blocks() {
      if (this.Favorites && this.Favorites.length) {
        return [...this.Favorites]
          .filter((el) => el.content_type !== 'webinar')
          .map(function (el) {
            if (el.object) {
              return {
                ...el.object,
                ...el.object?.translates?.[0],
                system_id: el.id,
                content_type: el.content_type,
              }
            } else {
              return false
            }
          })
          .filter((el) => el)
      }
      return []
    },
  },
  methods: {
    ...mapActions([
      'fetchFavorites',
      'DistributionSetVideoProgress',
      'DistributionSetLike',
      'DistributionSetFavorite',
      'DistributionSetView',
      'HnGrowSetVideoProgress',
      'HnGrowSetLike',
      'HnGrowSetFavorite',
      'HnGrowSetView',
      'WebinarsSetLike',
      'WebinarsSetFavorite',
      'WebinarsSetVideoProgress',
      'WebinarsMaterialSetLike',
      'WebinarsMaterialSetFavorite',
      'WebinarsLinkSetLike',
      'WebinarsLinkSetFavorite',
      'WebinarsSetView',
      'TrainingsSetVideoProgress',
      'TrainingsSetLike',
      'TrainingsSetFavorite',
      'TrainingsSetView',
      'academySetLike',
      'academySetFavorite',
      'academySetView',
      'academySetVideoProgress',
      'ScreencastsSetVideoProgress',
      'ScreencastsSetLike',
      'ScreencastsSetFavorite',
      'ScreencastsSetView',
      'IntensiveSetFavorite',
      'IntensiveSetLike',
      'IntensiveSetView',
    ]),
    choiceCategory(category) {
      if (category) {
        this.$router.push({
          ...this.$route,
          query: { category: category.type },
        })
      } else {
        this.$router.push({ ...this.$route, query: {} })
      }
      if (this.$gtm) {
        this.$gtm.push({
          event: 'lk_favorite_filters',
          param_value: this.helpers.stripHtml(category.title),
        })
      }
    },
    async like(id, category) {
      switch (category) {
        case 'videoblock':
          await this.DistributionSetLike(id)
          break
        case 'webinar':
          await this.WebinarsSetLike(id)
          break
        case 'material':
          await this.WebinarsMaterialSetLike(id)
          break
        case 'link':
          await this.WebinarsLinkSetLike(id)
          break
        case 'hngrowitem':
          await this.HnGrowSetLike(id)
          break
        case 'training':
          await this.TrainingsSetLike(id)
          break
        case 'successacademyelement':
          await this.academySetLike(id)
          break
        case 'intensivescreencast':
          await this.ScreencastsSetLike(id)
          break
        case 'intensivelesson':
          await this.IntensiveSetLike(id)
          break
      }

      await this.updateList()
    },
    async favorite(id, category) {
      switch (category) {
        case 'videoblock':
          await this.DistributionSetFavorite(id)
          break
        case 'webinar':
          await this.WebinarsSetFavorite(id)
          break
        case 'material':
          await this.WebinarsMaterialSetFavorite(id)
          break
        case 'link':
          await this.WebinarsLinkSetFavorite(id)
          break
        case 'hngrowitem':
          await this.HnGrowSetFavorite(id)
          break
        case 'training':
          await this.TrainingsSetFavorite(id)
          break
        case 'successacademyelement':
          await this.academySetFavorite(id)
          break
        case 'intensivescreencast':
          await this.ScreencastsSetFavorite(id)
          break
        case 'intensivelesson':
          await this.IntensiveSetFavorite(id)
          break
      }

      await this.updateList()
    },
    async setVideoProgress(id, time, category) {
      switch (category) {
        case 'videoblock':
          await this.DistributionSetVideoProgress({
            id: id,
            progress: Math.round(time),
          })
          break
        case 'webinar':
          await this.WebinarsSetVideoProgress({
            id: id,
            progress: Math.round(time),
          })
          break
        case 'hngrowitem':
          await this.HnGrowSetVideoProgress({
            id: id,
            progress: Math.round(time),
          })
          break
        case 'training':
          await this.TrainingsSetVideoProgress({
            id: id,
            progress: Math.round(time),
          })
          break
        case 'successacademyelement':
          await this.academySetVideoProgress({
            id: id,
            progress: Math.round(time),
          })
          break
        case 'intensivescreencast':
          await this.ScreencastsSetVideoProgress({
            id: id,
            progress: Math.round(time),
          })
          break
        case 'intensivelesson':
          await this.IntensiveSetVideoProgress({
            id: id,
            progress: Math.round(time),
          })
          break
      }

      await this.updateList()
    },
    async viewItem(id, category, access) {
      let addAccess = access && access.length
      switch (category) {
        case 'videoblock':
          await this.DistributionSetView(id)
          break
        case 'webinar':
          await this.WebinarsSetView(id)
          break
        case 'hngrowitem':
          await this.HnGrowSetView(id)
          break
        case 'training':
          await this.TrainingsSetView({ id: id, access: addAccess })
          break
        case 'successacademyelement':
          await this.academySetView(id)
          break
        case 'intensivescreencast':
          await this.ScreencastsSetView(id)
          break
        case 'intensivelesson':
          await this.IntensiveSetView(id)
          break
      }

      await this.updateList()
    },
    async updateList() {
      await this.fetchFavorites(this.currentCategory)
    },
  },
  async mounted() {
    this.fetchFavorites(this.currentCategory)
  },
  watch: {
    '$route.query': {
      handler: async function () {
        if (this.$route.query && this.$route.query.category) {
          this.currentCategory = this.$route.query.category
        }
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.favorites {
  &__filter {
    margin: 0 -8px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
  }
  @media screen and (max-width: 1220px) {
    &-main__title {
      border-bottom: 1px solid #d1d2cd;
    }
  }
}

.favorites-filter {
  &__item {
    margin: 8px;
    padding: 16px;
    border: 2px solid #707372;
    border-radius: 99px;
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 26px;
    color: color(dark-grey);
    cursor: pointer;
    transition: 0.3s;

    @media screen and (max-width: 743px) {
      padding: 8px 12px;
      margin-bottom: 16px;
    }

    &_active {
      color: color(dark);
      border-color: color(green-main);
    }

    &:hover {
      color: color(green-main);
    }
  }
}

.row-1-1 {
  grid-template-columns: 1fr 1fr;

  @media screen and (max-width: 1220px) {
    grid-template-columns: 1fr;
  }
}

.gap-32 {
  grid-gap: 32px;
}
</style>
